"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpotWind = void 0;
var _react = _interopRequireDefault(require("react"));
var _SVG = require("../SVG");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SpotWind = _ref => {
  let {
    spotColor = "#C6F4EC",
    color = "#13126C",
    strokeWidth = "2.2",
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#Spot=on,_Size=40_svg__a)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: spotColor,
    d: "M7.104 27.327c.825 3.551 1.785 8.057 4.309 9.776 2.553 1.746 6.698.734 9.753-1.243 3.055-1.948 5.021-4.83 7.433-7.143 2.411-2.312 5.298-4.024 7.353-6.822 2.026-2.768 3.249-6.593 3.02-10.65-.227-4.056-1.907-8.345-5.22-9.118-3.314-.745-8.234 1.995-11.972 3.086-3.768 1.092-6.296.534-10.122.206-3.825-.328-8.92-.428-10.262 1.804C.053 9.426 2.43 13.962 4.009 17.527c1.55 3.594 2.24 6.22 3.095 9.8Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth,
    d: "M17.372 6.813a3.333 3.333 0 1 1 .96 6.52h-15m19.04 19.855a3.334 3.334 0 1 0 .96-6.521h-20m26.217-13.783A4.167 4.167 0 1 1 32.499 20H3.332"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "Spot=on,_Size=40_svg__a"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  }))));
};
exports.SpotWind = SpotWind;
SpotWind.displayName = "SpotWind";